@if (results && results.length) {
  <div class="eurostar-list">
    <div class="eurostar-list_header">
      @if (resType === ResultType.Outbound) {
        <span i18n="@@eursotarOutbound">Outbound</span>
      }
      @if (resType === ResultType.Inbound) {
        <span i18n="@@flightLegReturn">Return</span>
      }
    </div>
    @for (item of results; track item; let j = $index) {
      <div class="eurostar-list_item half-container flex-row-container--tb-margin">
        <div class="half-block flex-row-container logo_time">
          <div class="logo-container">
            <img [src]="eurostarLogo" class="eurostar-list_item-logo" alt="Eurostar Logo" />
          </div>
          <div class="eurostar-list_schedule flex-row-container">
            <div class="eurostar-list_time">
              {{ item.timeDeparture }}
              @if (item.timeDepartureOffset) {
                <section (mouseleave)="ttOff1.close()">
                  <div
                    class="offset_notification"
                    ngbTooltip="{{ item.departureCountryCode }} time is +{{
                      item.timeDepartureOffset
                    }} from UK time"
                    placement="right"
                    tooltipClass="custom-tooltip"
                    triggers="manual"
                    #ttOff1="ngbTooltip"
                    (mouseenter)="ttOff1.open()"
                    (focus)="ttOff1.open()"
                    (blur)="ttOff1.close()"
                    tabindex="0"
                  >
                    +{{ item.timeDepartureOffset }}
                  </div>
                </section>
              }
            </div>
            <div class="eurostar-list_duration">{{ item.duration }}</div>
            <div class="eurostar-list_time">
              {{ item.timeArrival }}
              @if (item.timeArrivalOffset) {
                <section (mouseleave)="ttOff2.close()">
                  <div
                    class="offset_notification"
                    ngbTooltip="{{ item.arrivalCountryCode }} time is +{{
                      item.timeArrivalOffset
                    }} from UK time"
                    placement="right"
                    tooltipClass="custom-tooltip"
                    tooltipClass="custom-tooltip"
                    triggers="manual"
                    #ttOff2="ngbTooltip"
                    (mouseenter)="ttOff2.open()"
                    (focus)="ttOff2.open()"
                    (blur)="ttOff2.close()"
                    tabindex="0"
                  >
                    +{{ item.timeArrivalOffset }}
                  </div>
                </section>
              }
            </div>
            <div class="eurostar-list_legs">
              <span class="eurostar-list_leg" i18n="@@eurostarListDirect">Direct</span>
            </div>
          </div>
          <app-preferred-icons
            [tmcPreferred]="
              item.standardFare.tmcPreferred ||
              item.standardPremierFare.tmcPreferred ||
              item.businessPremierFare.tmcPreferred
            "
            [tmcPreferredLogoUrl]="
              item.standardFare.tmcPreferredLogoUrl ||
              item.standardPremierFare.tmcPreferredLogoUrl ||
              item.businessPremierFare.tmcPreferredLogoUrl
            "
            [tmcPreferredMessage]="
              item.standardFare.tmcPreferredMessage ||
              item.standardPremierFare.tmcPreferredMessage ||
              item.businessPremierFare.tmcPreferredMessage
            "
            [clientPreferred]="
              item.standardFare.companyPreferred ||
              item.standardPremierFare.companyPreferred ||
              item.businessPremierFare.companyPreferred ||
              item.standardFare.officePreferred ||
              item.standardPremierFare.officePreferred ||
              item.businessPremierFare.officePreferred
            "
            [companyPreferredMessage]="
              item.standardFare.companyPreferredMessage ||
              item.standardPremierFare.companyPreferredMessage ||
              item.businessPremierFare.companyPreferredMessage
            "
            [officePreferredMessage]="
              item.standardFare.officePreferredMessage ||
              item.standardPremierFare.officePreferredMessage ||
              item.businessPremierFare.officePreferredMessage
            "
          >
          </app-preferred-icons>
        </div>
        <!--  -->
        <div class="half-block flex-row-container">
          @if (showClasses.standard) {
            <button
              (click)="toggleFare(item, item.standardFare)"
              aria-labelledby=""
              [disabled]="
                (item.standardFare.isDisabled ||
                  searchParams.selectedFareClass === EuroClass.Business ||
                  item.standardFare.unavailable ||
                  (this.resType === ResultType.Inbound &&
                    !this.searchParams.selectedEurostarFare)) &&
                !canOverride
              "
              [ngClass]="{ 'eurostar-list_item-fare--selected': fareIsSelected(item.standardFare) }"
              class="eurostar-list_item-fare"
              id="{{ !!item.standardFare.price ? 'standard-ticket' : 'no-ticket' }}"
            >
              <div class="flex-row-container">
                <span class="sr-only" i18n="@@eurostarListStandardFare"
                  >Eurostar Standard fare</span
                >
                @if (
                  resType === ResultType.Outbound ||
                  newFareHasLoaded(item.standardFare) ||
                  item.sourceId !== sabreServiceId
                ) {
                  <span
                    [ngClass]="{ strike: fareIsSelected(item.standardFare) }"
                    id="{{ !!item.standardFare.price ? 'price' : 'no-price' }}"
                    >{{ item.standardFare.price | currency: item.standardFare.currency }}</span
                  >
                }
                @if (
                  resType === ResultType.Inbound &&
                  item.standardFare !== loadingFare &&
                  !newFareHasLoaded(item.standardFare) &&
                  item.sourceId === sabreServiceId
                ) {
                  <span
                    class="load_new_fare"
                    i18n="@@eurostarLoadNewFee"
                    id="standardLoadingFareImage"
                    >Load new fare...<span class="sr-only"
                      >Old fare:
                      {{ item.standardFare.price | currency: item.standardFare.currency }}</span
                    ></span
                  >
                }
                @if (item.standardFare === loadingFare) {
                  <mat-spinner [diameter]="20" [color]="'black'"></mat-spinner>
                }
                @if (item.standardFare.price) {
                  <app-warning-tags
                    [ticket]="item.standardFare"
                    iconId="standardFare-{{ j }}"
                    [isUnavailableOnly]="item.standardFare.unavailable"
                  ></app-warning-tags>
                }
              </div>
              @if (item.standardFare.price && item.co2PerPassenger) {
                <span class="co2-display">{{ item.co2PerPassenger }}kg CO<sub>2</sub> pp</span>
              }
            </button>
          }
          @if (showClasses.standardPremier) {
            <button
              (click)="toggleFare(item, item.standardPremierFare)"
              [disabled]="
                (item.standardPremierFare.isDisabled ||
                  searchParams.selectedFareClass === EuroClass.Business ||
                  item.standardPremierFare.unavailable ||
                  (this.resType === ResultType.Inbound &&
                    !this.searchParams.selectedEurostarFare) ||
                  (this.resType === ResultType.Inbound &&
                    !this.searchParams.selectedEurostarFare)) &&
                !canOverride
              "
              class="eurostar-list_item-fare"
              [ngClass]="{
                'eurostar-list_item-fare--selected': fareIsSelected(item.standardPremierFare)
              }"
              id="{{ !!item.standardPremierFare.price ? 'standard-premier-ticket' : 'no-ticket' }}"
            >
              <div class="flex-row-container">
                <span class="sr-only" i18n="@@eurostarListStandardPremier">Eurostar plus fare</span>
                @if (
                  resType === ResultType.Outbound ||
                  newFareHasLoaded(item.standardPremierFare) ||
                  item.sourceId !== sabreServiceId
                ) {
                  <span
                    [ngClass]="{ strike: fareIsSelected(item.standardPremierFare) }"
                    id="{{ !!item.standardPremierFare.price ? 'price' : 'no-price' }}"
                    >{{
                      item.standardPremierFare.price | currency: item.standardFare.currency
                    }}</span
                  >
                }
                @if (
                  resType === ResultType.Inbound &&
                  item.standardPremierFare !== loadingFare &&
                  !newFareHasLoaded(item.standardPremierFare) &&
                  item.sourceId === sabreServiceId
                ) {
                  <span
                    class="load_new_fare"
                    i18n="@@eurostarLoadNewFee"
                    id="standardPremierLoadingFareImage"
                    >Load new fare...<span class="sr-only"
                      >Old fare:
                      {{
                        item.standardPremierFare.price | currency: item.standardFare.currency
                      }}</span
                    ></span
                  >
                }
                @if (item.standardPremierFare === loadingFare) {
                  <mat-spinner [diameter]="20" [color]="'black'"></mat-spinner>
                }
                @if (item.standardPremierFare.price) {
                  <app-warning-tags
                    [ticket]="item.standardPremierFare"
                    iconId="standardPremierFare-{{ j }}"
                    [isUnavailableOnly]="item.standardPremierFare.unavailable"
                  ></app-warning-tags>
                }
              </div>
              @if (item.standardPremierFare.price && item.co2PerPassenger) {
                <span class="co2-display">{{ item.co2PerPassenger }}kg CO<sub>2</sub> pp</span>
              }
            </button>
          }
          @if (showClasses.businessPremier) {
            <button
              (click)="toggleFare(item, item.businessPremierFare)"
              [disabled]="
                (item.businessPremierFare.isDisabled ||
                  searchParams.selectedFareClass === EuroClass.EconomyRestricted ||
                  searchParams.selectedFareClass === EuroClass.Premium ||
                  searchParams.selectedFareClass === EuroClass.EconomyNoBags ||
                  searchParams.selectedFareClass === EuroClass.EconomyFlexi ||
                  item.businessPremierFare.unavailable ||
                  (this.resType === ResultType.Inbound &&
                    !this.searchParams.selectedEurostarFare)) &&
                !canOverride
              "
              class="eurostar-list_item-fare"
              id="{{ !!item.businessPremierFare.price ? 'business-premier-ticket' : 'no-ticket' }}"
              [ngClass]="{
                'eurostar-list_item-fare--selected': fareIsSelected(item.businessPremierFare)
              }"
            >
              <div class="flex-row-container">
                <span
                  class="sr-only"
                  i18n="@@eurostarListBusinessPremier"
                  id="{{ !!item.businessPremierFare.price ? 'price' : 'no-price' }}"
                  >Eurostar Premier fare</span
                >
                @if (
                  resType === ResultType.Outbound ||
                  newFareHasLoaded(item.businessPremierFare) ||
                  item.sourceId !== sabreServiceId
                ) {
                  <span
                    [ngClass]="{ strike: fareIsSelected(item.businessPremierFare) }"
                    id="{{ !!item.businessPremierFare.price ? 'price' : 'no-price' }}"
                    >{{
                      item.businessPremierFare.price | currency: item.standardFare.currency
                    }}</span
                  >
                }
                @if (
                  resType === ResultType.Inbound &&
                  item.businessPremierFare !== loadingFare &&
                  !newFareHasLoaded(item.businessPremierFare) &&
                  item.sourceId === sabreServiceId
                ) {
                  <span
                    class="load_new_fare"
                    i18n="@@eurostarLoadNewFee"
                    id="businessPremierLoadingFareImage"
                    >Load new fare...<span class="sr-only"
                      >Old fare:
                      {{
                        item.businessPremierFare.price | currency: item.standardFare.currency
                      }}</span
                    ></span
                  >
                }
                @if (item.businessPremierFare === loadingFare) {
                  <mat-spinner [diameter]="20" [color]="'black'"></mat-spinner>
                }
                @if (item.businessPremierFare.price) {
                  <app-warning-tags
                    [ticket]="item.businessPremierFare"
                    iconId="businessPremierFare-{{ j }}"
                    [isUnavailableOnly]="item.businessPremierFare.unavailable"
                  ></app-warning-tags>
                }
              </div>
              @if (item.businessPremierFare.price && item.co2PerPassenger) {
                <span class="co2-display">{{ item.co2PerPassenger }}kg CO<sub>2</sub> pp</span>
              }
            </button>
          }
        </div>
      </div>
    }
  </div>
}
